import React, { useState, useEffect } from 'react'
import {
  Table,
  Icon,
  Panel,
  Row,
  Col,
  ControlLabel,
  SelectPicker,
  Input,
  Checkbox,
  Message,
  Button,
} from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import {
  getMaxLengthData,
  isRequired,
  isValidators,
  requiredFiled,
} from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import './styles.less'
import AlertWidget from '../confirm/AlertWidget'
import globalMsgUtil from '../../utils/globalMsgUtil'
import ConfirmWidget from '../confirm/ConfirmWidget'
import EditButton from '../../components/buttons/editButton/EditButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import pathname from '../../constants/pathname'
import { useHistory } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import { sessionGetItemObj, sessionGetItemStr } from '../../utils/sessionHelpers'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { getValueFromOptions } from '../../utils/dataUtil'
import { budgetFormat } from '../../utils/formatterUtil'
import classNames from 'classnames'
import InputForm from '../../components/forms/input/InputForm'

export default function AssetRequestManagementDetailTable({
  schema,
  formSchema,
  loading,
  onReload = () => {},
  onSelect = () => {},
  onViewFiles = () => {},
  onSave = () => {},
  isApprover,
  userRole,
  isProposalStep,
  isEditForProposalStep,
  setIsEditForProposalStep = () => {},
  onPreview = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const { register, handleSubmit, errors, control, getValues, setValue, clearErrors } = useForm()

  const [tableData, setTableData] = useState([])
  const [requestForProject, setRequestForProject] = useState(schema?.requestForProject?.value || '')
  const [checkedAll, setCheckedAll] = useState(false)
  const [indeterminate, setIndeterminate] = useState(false)
  const [checkedKeys, setCheckedKeys] = useState([])
  const [isShowModalHelper, setIsShowModalHelper] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [countSelected, setCountSelected] = useState(0)
  const [bodyRequest, setBodyRequest] = useState()
  const [txtConfirmMsg, setConfirmMsg] = useState('')

  const fs = localStorage.getItem('fontSize')
  const bookingInfo = sessionGetItemObj('bookingInfo')
  const history = useHistory()
  const isViewOnly = !!sessionGetItemStr('isViewOnly')
  const txtConf = 'ยืนยัน'

  useEffect(() => {
    if (formSchema?.assetIds?.length > 0) {
      setCheckedKeys(formSchema.assetIds)
      setCountSelected(formSchema?.assetIds?.length)
      isProposalStep && setIsEditForProposalStep(false)
    }
  }, [formSchema.assetIds])

  useEffect(() => {
    if (isProposalStep && !isEditForProposalStep) {
      //isProposalStep
      if (schema?.values.length > 0) {
        const filtered = schema?.values.filter((i) => formSchema?.assetIds?.includes(i.id))
        setTableData(filtered)
      }
    } else {
      //normal step
      schema?.values?.length > 0 ? setTableData(schema?.values) : setTableData([])

      if (isProposalStep && formSchema?.assetIds?.length > 0) {
        setCheckedKeys(formSchema.assetIds)
        //setIsEditForProposalStep(false)
      }
    }
  }, [schema.values, isEditForProposalStep, formSchema.assetIds])

  const handleCheckAll = (value, checked) => {
    // console.log('value : ', value, ', checked: ', checked)
    const keys = checked ? tableData?.map((item) => item.id) : []

    setCheckedAll(checked)
    setIndeterminate(false)
    setCheckedKeys(keys)
    setCountSelected(keys.length)
  }

  const handleCheck = (value, checked) => {
    const keys = checked ? [...checkedKeys, value] : checkedKeys.filter((item) => item !== value)

    if (keys.length === 0) {
      setCheckedAll(false)
    } else if (keys.length > 0 && keys.length < tableData?.length) {
      setIndeterminate(true)
    }

    setCheckedKeys(keys)
    setCountSelected(keys.length)
  }

  const handleCheckRequest = async (data) => {
    // console.log('handleCheckRequest', data)
    // console.log('checkedKeys ', checkedKeys)

    if (!isProposalStep && checkedKeys.length <= 0) {
      setIsShowModalHelper(true)
      return false
    }

    const request = {
      id: bookingInfo.id ? bookingInfo.id : null,
      assetIds: checkedKeys,
      requestForProject: data.requestForProject || '',
      note: data.note || '',
      status: 1,
      isProposalStep: isProposalStep ? true : false,
    }

    setConfirmMsg(`${txtConf}${formSchema.form.button.request || formSchema.form.button.save}`)

    setBodyRequest(request)
    setIsShowConfirm(true)
    // onSave(request)
  }

  const handleCancelReserve = async (data) => {
    console.log('handleCancelReserve', data)
    console.log('checkedKeys ', checkedKeys)

    const request = {
      id: bookingInfo.id,
      note: data.note || '',
      status: 4,
    }

    setConfirmMsg(`${txtConf}${formSchema.form.button.cancelReserve}`)

    setBodyRequest(request)
    setIsShowConfirm(true)
  }

  const handleReturnEdit = async (data) => {
    const request = {
      id: bookingInfo.id,
      // note: data?.note || data?.comment || '',
      comment: data?.note || data?.comment || '',
      status: 2,
    }

    setConfirmMsg(`${txtConf}${formSchema.form.button.returnEdit}`)

    setBodyRequest(request)
    setIsShowConfirm(true)
  }

  const handleApprove = async (data) => {
    // console.log('handleApprove ', data)
    const request = {
      id: bookingInfo.id,
      // note: data?.note || data?.comment || '',
      comment: data?.note || data?.comment || '',
      status: 3,
    }

    setConfirmMsg(`${txtConf}${formSchema.form.button.approve}`)

    setBodyRequest(request)
    setIsShowConfirm(true)
  }

  const handleApproveCancelReserve = async (data) => {
    const request = {
      id: bookingInfo.id,
      note: data.note || '',
      status: 5,
    }

    setConfirmMsg(`${txtConf}${formSchema.form.button.approveCancelReserve}`)

    setBodyRequest(request)
    setIsShowConfirm(true)
  }

  const handleConfSave = async () => {
    const res = await onSave(bodyRequest)

    if (res) {
      setIsShowConfirm(false)
      setBodyRequest()

      if (isProposalStep) {
        return
      }

      history.push({
        pathname: formSchema?.isApprover
          ? pathname.durableArticles.AssetRequestManagementApprove
          : pathname.durableArticles.AssetRequestManagement,
      })
    }
  }

  return (
    <>
      {loading && <OverlayLoader />}
      <Panel collapsible defaultExpanded header={' '} bordered style={{ marginTop: 20 }}>
        <div className="table-all-articles">
          <Table
            wordWrap
            // minHeight={400}
            // autoHeight
            height={600}
            loading={loading}
            headerHeight={fs <= 15 ? undefined : fs < 16 ? 70 : fs <= 18 ? 75 : 80}
            data={tableData || []}
            style={{ marginTop: '10px' }}
            affixHeader={isProposalStep ? false : true}
          >
            {formSchema?.disabled || formSchema?.isApprover || !isEditForProposalStep ? (
              <Column width={95} align="center">
                <HeaderCell>ลำดับ</HeaderCell>
                <Cell style={{ padding: 0 }}>
                  {(rowData, index) => {
                    return <>{index + 1}</>
                  }}
                </Cell>
              </Column>
            ) : (
              <Column width={95} align="center">
                <HeaderCell>
                  <Checkbox
                    style={{ marginTop: '-7px', marginLeft: -10 }}
                    inline
                    checked={checkedAll}
                    indeterminate={indeterminate}
                    disabled={isViewOnly}
                    onChange={handleCheckAll}
                  />
                  <b>ลำดับ</b>
                </HeaderCell>
                <Cell style={{ padding: 0 }}>
                  {(rowData, index) => {
                    return (
                      <>
                        <div style={{ marginTop: 10 }}>
                          <Checkbox
                            style={{ marginTop: '-7px', marginLeft: -10 }}
                            value={rowData.id}
                            //disabled={isViewOnly}
                            inline
                            onChange={(value, checked) => handleCheck(value, checked, rowData)}
                            checked={checkedKeys.some((item) => item === rowData.id)}
                          />
                          {index + 1}
                        </div>
                      </>
                    )
                  }}
                </Cell>
              </Column>
            )}

            <Column width={180}>
              <HeaderCell>รหัสครุภัณฑ์</HeaderCell>
              <Cell dataKey="assetCode" />
            </Column>

            <Column minWidth={200} flexGrow={1}>
              <HeaderCell>ชื่อครุภัณฑ์</HeaderCell>
              <Cell dataKey="assetName" />
            </Column>

            <Column width={120}>
              <HeaderCell>ราคา/หน่วย</HeaderCell>
              <Cell style={{ textAlign: 'right' }}>
                {(rowData) => {
                  return budgetFormat(rowData.assetAmount)
                }}
              </Cell>
            </Column>

            <Column width={160}>
              <HeaderCell>รุ่น</HeaderCell>
              <Cell dataKey="assetModel" />
            </Column>

            <Column width={160}>
              <HeaderCell>ยี่ห้อ </HeaderCell>
              <Cell dataKey="assetBrand" />
            </Column>

            <Column width={160}>
              <HeaderCell>ประเภทครุภัณฑ์ </HeaderCell>
              <Cell dataKey="assetType" />
            </Column>

            <Column width={160}>
              <HeaderCell>รูปภาพครุภัณฑ์</HeaderCell>
              <Cell>
                {(rowData) => {
                  if (!rowData.assetImg) {
                    return ''
                  }
                  return (
                    <>
                      <a
                        style={{ cursor: 'pointer', textDecorationLine: 'underline' }}
                        onClick={(_) => {
                          // console.log(rowData)
                          onViewFiles(`${rowData?.assetCode || '__'}`, rowData?.assetImg || null)
                        }}
                      >
                        <Icon icon="file-image-o" style={{ marginRight: '5px' }} />
                        คลิกดูรูปภาพ
                      </a>
                    </>
                  )
                }}
              </Cell>
            </Column>
          </Table>
        </div>
      </Panel>
      {formSchema?.form?.inputForm && (
        <>
          {formSchema.currentStatus && (
            <Row style={{ marginTop: 30 }}>
              <Col lg={5} md={5} sm={24} xs={24} style={{ textAlign: 'right' }}>
                สถานะการขอใช้ :
              </Col>
              <Col lg={14} md={14} sm={24} xs={24}>
                {formSchema.currentStatus.label}
              </Col>
              <Col lg={5} md={5} sm={24} xs={24}></Col>
            </Row>
          )}

          {!isViewOnly && !formSchema?.isApprover && isEditForProposalStep ? (
            <>
              <Row style={{ marginTop: 20 }}>
                <Col lg={5} md={5} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <ControlLabel
                    className={classNames(
                      isRequired(formSchema.form.inputForm.requestForProject.validators) &&
                        'required'
                    )}
                  >
                    {formSchema.form.inputForm.requestForProject.label}
                  </ControlLabel>
                </Col>
                <Col lg={14} md={14} sm={24} xs={24}>
                  <ErrorMessage error={errors[formSchema.form.inputForm.requestForProject.name]} />
                  <Controller
                    name={formSchema.form.inputForm.requestForProject.name}
                    control={control}
                    defaultValue={formSchema.form.inputForm.requestForProject.value}
                    rules={isValidators(formSchema.form.inputForm.requestForProject.validators)}
                    render={(props) => {
                      return (
                        <SelectPicker
                          style={{ minWidth: '100%' }}
                          virtualized={false}
                          searchable={true}
                          data={formSchema.form.inputForm.requestForProject.options}
                          value={props.value}
                          menuAutoWidth
                          placeholder={'เลือก' + formSchema.form.inputForm.requestForProject.label}
                          disabled={formSchema.form.inputForm.requestForProject.disabled}
                          onChange={(value) => {
                            props.onChange(value)
                            setRequestForProject(value)
                            // setAccChannel(value)
                            // setIsEnableEdit(value != confirmAccChannel)
                          }}
                        />
                      )
                    }}
                  />
                </Col>
                <Col lg={5} md={5} sm={24} xs={24}></Col>
              </Row>

              <Row style={{ marginTop: 20 }}>
                <Col lg={5} md={5} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <ControlLabel
                    className={classNames(
                      isRequired(formSchema.form.inputForm.note.validators) && 'required'
                    )}
                  >
                    {formSchema.form.inputForm.note.label}
                  </ControlLabel>
                </Col>
                <Col lg={14} md={14} sm={24} xs={24}>
                  <InputForm
                    schema={formSchema.form.inputForm.note}
                    register={register}
                    row={3}
                    componentClass="textarea"
                    hideLabel
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </Col>
                <Col lg={5} md={5} sm={24} xs={24}></Col>
              </Row>
            </>
          ) : (
            <>
              <Row style={{ marginTop: 10 }}>
                <Col lg={5} md={5} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  {formSchema.form.inputForm.requestForProject.label + ' : '}
                </Col>
                <Col lg={14} md={14} sm={24} xs={24}>
                  {formSchema.form.inputForm.requestForProject.valueDef
                    ? formSchema.form.inputForm.requestForProject.valueDef
                    : formSchema.form.inputForm.requestForProject.value
                      ? getValueFromOptions(
                          formSchema.form.inputForm.requestForProject.options,
                          formSchema.form.inputForm.requestForProject.value
                        )
                      : '-ไม่ระบุ-'}
                </Col>
                <Col lg={5} md={5} sm={24} xs={24}></Col>
              </Row>
              <Row style={{ marginTop: 20 }}>
                <Col lg={5} md={5} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  {formSchema.form.inputForm.note.label + ' : '}
                </Col>
                <Col lg={14} md={14} sm={24} xs={24}>
                  {formSchema.form.inputForm.note.value || '-ไม่ระบุ-'}
                </Col>
                <Col lg={5} md={5} sm={24} xs={24}></Col>
              </Row>
            </>
          )}
        </>
      )}

      {formSchema?.inputForm?.comments?.map((item) => {
        return (
          <Row style={{ marginTop: 10 }}>
            <Col lg={5} md={5} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <p>{`${item.label} : `}</p>
            </Col>
            <Col lg={14} md={14} sm={24} xs={24}>
              <Message type="info" description={item.value} />
            </Col>
            <Col lg={5} md={5} sm={24} xs={24}></Col>
          </Row>
        )
      })}

      {formSchema?.form?.inputForm?.comments?.map((item) => {
        return (
          <Row style={{ marginTop: 10 }}>
            <Col lg={5} md={5} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <p>{`${item.label} : `}</p>
            </Col>
            <Col lg={14} md={14} sm={24} xs={24}>
              <Message type="info" description={item.value} />
            </Col>
            <Col lg={5} md={5} sm={24} xs={24}></Col>
          </Row>
        )
      })}

      {formSchema.isApprover && formSchema.form.inputForm.comment && (
        <Row style={{ marginTop: 20 }}>
          <Col lg={5} md={5} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {!isViewOnly ? (
              <>
                <ControlLabel>
                  {requiredFiled(
                    formSchema.form.inputForm.comment.validators,
                    formSchema.form.inputForm.comment.label
                  )}
                </ControlLabel>
              </>
            ) : (
              <>{formSchema.form.inputForm.comment.label + ' : '}</>
            )}
          </Col>
          <Col lg={14} md={14} sm={24} xs={24}>
            {!isViewOnly ? (
              <>
                <ErrorMessage error={errors[formSchema.form.inputForm.comment.name]} />
                <Controller
                  name={formSchema.form.inputForm.comment.name}
                  control={control}
                  defaultValue={formSchema.form.inputForm.comment.value}
                  rules={isValidators(formSchema.form.inputForm.comment.validators)}
                  render={(props) => {
                    return (
                      <Input
                        placeholder={'ระบุ' + formSchema.form.inputForm.comment.label}
                        value={props.value}
                        componentClass={'textarea'}
                        maxLength={
                          getMaxLengthData(formSchema.form.inputForm.comment.validators).value
                        }
                        onChange={(value, e) => {
                          props.onChange(value)
                        }}
                        disabled={formSchema.form.inputForm.comment.disabled}
                      />
                    )
                  }}
                />
              </>
            ) : (
              <>{formSchema.form.inputForm.comment.value || '-ไม่ระบุ-'}</>
            )}
          </Col>
          <Col lg={5} md={5} sm={24} xs={24}></Col>
        </Row>
      )}
      {isEditForProposalStep ? (
        <Row style={{ marginTop: 30 }}>
          <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.form.button.reserveDoc && (
              <Button
                color="blue"
                appearance="link"
                disabled={!bookingInfo.id}
                onClick={() => {
                  onPreview()
                }}
                style={{
                  marginRight: 10,
                  marginBottom: 10,
                }}
              >
                <Icon icon="eye" size="lg" /> {formSchema.form.button.reserveDoc}
              </Button>
            )}

            {!isViewOnly && (
              <>
                {formSchema.form.button.approve && (
                  <SaveButton
                    disabled={loading}
                    icon="check-circle"
                    children={formSchema.form.button.approve}
                    onClick={handleSubmit(handleApprove)}
                  />
                )}

                {/* {formSchema.form.button.approveCancelReserve && (
                  <SaveButton
                    disabled={loading}
                    icon="check-circle"
                    children={formSchema.form.button.approveCancelReserve}
                    onClick={handleSubmit(handleApproveCancelReserve)}
                  />
                )} */}

                {formSchema.form.button.returnEdit && (
                  <EditButton
                    disabled={loading}
                    children={formSchema.form.button.returnEdit}
                    onClick={handleSubmit(handleReturnEdit)}
                  />
                )}

                {/* ยกเลิกการขอใช้ */}
                {formSchema.form.button.cancelReserve && (
                  <EditButton
                    disabled={loading}
                    onClick={handleSubmit(handleCancelReserve)}
                    icon="close"
                  >
                    {formSchema.form.button.cancelReserve}
                  </EditButton>
                )}

                {/* ขออนุมัติ */}
                {formSchema.form.button.request && (
                  <SaveButton
                    disabled={loading}
                    icon="send"
                    onClick={handleSubmit(handleCheckRequest)}
                  >
                    {`${formSchema.form.button.request} (${countSelected} รายการ)`}
                  </SaveButton>
                )}

                {/* บันทึก */}
                {formSchema.form.button.save && (
                  <SaveButton
                    disabled={loading}
                    icon="save"
                    onClick={handleSubmit(handleCheckRequest)}
                  >
                    {`${formSchema.form.button.save} (${countSelected} รายการ)`}
                  </SaveButton>
                )}
              </>
            )}

            {/* ยกเลิก */}
            {formSchema.form.button.cancel && (
              <CancelButton
                onClick={(_) => {
                  if (isProposalStep) {
                    setIsEditForProposalStep(!isEditForProposalStep)
                    return
                  }
                  history.push({
                    pathname: formSchema.isApprover
                      ? pathname.durableArticles.AssetRequestManagementApprove
                      : pathname.durableArticles.AssetRequestManagement,
                  })
                }}
              >
                {formSchema.form.button.cancel}
              </CancelButton>
            )}
          </Col>
        </Row>
      ) : (
        <Row style={{ marginTop: 30 }}>
          <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {/* แก้ไข isProposalStep */}
            <EditButton
              disabled={loading}
              onClick={() => setIsEditForProposalStep(!isEditForProposalStep)}
            >
              แก้ไข
            </EditButton>
          </Col>
        </Row>
      )}
      <AlertWidget
        title={globalMsgUtil.WARN_SELECTED_ITEM_TITLE}
        show={isShowModalHelper}
        detail={globalMsgUtil.WARN_SELECTED_ITEM_DETAIL}
        onClose={() => {
          setIsShowModalHelper(false)
        }}
      />

      <ConfirmWidget
        // title={globalMsgUtil.CONFIRM_SAVE_TITLE}
        title={txtConfirmMsg}
        show={isShowConfirm}
        detail={globalMsgUtil.CONFIRM_SAVE_DETAIL}
        onCancle={() => setIsShowConfirm(false)}
        onConfirm={handleConfSave}
      />
    </>
  )
}
